import React, { useEffect } from 'react'
import { useDrag, DragElementWrapper } from 'react-dnd'
import { getEmptyImage } from 'react-dnd-html5-backend'
import { Avatar, EmployeeSpaceAssignment, Flex, HighlightedText } from '@ui'
import { MenuItem, IMenuItemProps, Checkbox } from '@blueprintjs/core'
import { ICatalogEmployee } from '@api'

interface EmployeeCardProps extends IMenuItemProps {
  employee: ICatalogEmployee
  query: string
  refItem?: any
  draggable?: boolean
  selected?: boolean
  multi?: boolean
}

export default function (props: EmployeeCardProps) {
  return props.draggable ? <DraggableEmployeeCard {...props} /> : <EmployeeCard {...props} />
}

function DraggableEmployeeCard(props: EmployeeCardProps) {
  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: 'Employee', data: props.employee },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  })

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true })
  }, [preview])

  return <EmployeeCard {...props} {...{ drag, isDragging }} />
}

function EmployeeCard({
  active,
  disabled,
  employee,
  query,
  refItem,
  drag,
  selected,
  isDragging,
  multi,
  onClick,
}: EmployeeCardProps & {
  drag?: DragElementWrapper<any>
  isDragging?: boolean
}) {
  return (
    <MenuItem
      style={{ width: 280, cursor: isDragging ? 'grabbing' : 'pointer' }}
      active={active}
      disabled={disabled}
      onClick={(e: React.MouseEvent<HTMLElement>) => {
        multi && e.preventDefault()
        onClick && onClick(e)
      }}
      labelElement={
        <div style={{ marginTop: 6, width: '75px' }}>
          <EmployeeSpaceAssignment {...employee} />
        </div>
      }
      text={
        <div ref={drag}>
          <Flex style={{ width: '200px' }} ref={refItem} align="center">
            {multi && <Checkbox checked={selected} />}
            <div style={{ marginRight: 8 }}>
              <Avatar size={Avatar.Size.XS} name={employee.name} assets={employee.assets} />
            </div>
            <HighlightedText text={employee.name} email={employee.email} query={query} />
          </Flex>
        </div>
      }
    />
  )
}
